<template>
  <div class="card card-alert" v-bind:class="[ readonly === true ? 'readOnly' : 'normalMode' ]">
    <div class="card-inner">
      <div class="title-container">
                    <span class="icon">
                        <slot name="icon"></slot>
                    </span>
        <span class="title">
                        <slot name="title"></slot>
                        <!-- <BadgeNew v-if="alertKey === 'lostcom'" class="ml-2" /> -->
                    </span>
      </div>
      <div class="content-container">
        <slot></slot>

        <div v-if="!!alerts">

          <hr class="separator" />

          <!-- Switcher buttons to propose the alarms options -->
          <span> {{ $t('profile.form.trigger') }}</span>

          <b-form-checkbox :id="alertKey + '-sound-button'"
                          v-if="!!alerts.sound" 
                          class="switch-selecter sound-switch"
                          :checked="this.alerts.sound.value == true ? true : false"
                          :title="getTooltipForAlert(alertKey,'sound')"
                          @change="toggleAlert('sound')"
                          :disabled="readonly"
                          switch>
            {{ $t('profile.form.sound') }}
          </b-form-checkbox>

          <b-form-checkbox :id="alertKey + '-vibrator-button'"
                          v-if="!!alerts.vibrator" 
                          class="switch-selecter"
                          :checked="this.alerts.vibrator.value == true ? true : false"
                          :title="getTooltipForAlert(alertKey,'vibrator')"
                          @change="toggleAlert('vibrator')"
                          :disabled="readonly"
                          switch>
            {{ $t('profile.form.vibration') }}
          </b-form-checkbox>

          <b-form-checkbox :id="alertKey + '-flash-button'"
                          v-if="!!alerts.flash" 
                          class="switch-selecter flash-button"
                          :checked="this.alerts.flash.value == true ? true : false"
                          :title="getTooltipForAlert(alertKey,'flash')"
                          @change="toggleAlert('flash')"
                          :disabled="readonly"
                          switch>
            {{ $t('profile.form.flash') }}
          </b-form-checkbox>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "@/services/utils.js";
import {BFormCheckbox} from "bootstrap-vue";
// import BadgeNew from "@/components/ui/BadgeNew";

export default {
  name: 'CardAlert',
  components: {
    BFormCheckbox,
    // BadgeNew,
  },
  props: {
    alertKey: {
      type: String,
      required: true
    },
    alerts: {
      type: Object,
      required: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: null,
    }
  },
  methods: {
    toggleAlert: function (alertKey) {
      if (this.readonly) {
        return false;
      }
      if (this.alerts[alertKey].value == 1) {
        this.alerts[alertKey].value = 0;
      } else {
        this.alerts[alertKey].value = 1;
      }
      this.$emit('change', parseInt(this.alerts[alertKey].value));
    },
    getTooltipForAlert: function (key, key2) {
      var tooltip = '';
      var tradKey = key;
      if (key2 != null) {
        tradKey += '.alert.' + key2;
      }
      if (Utils.te('profile.items.' + tradKey)) {
        tooltip = Utils.t('profile.items.' + tradKey);
      }
      return tooltip;
    }
  }
}
</script>

<style lang="scss" scoped>
.card-alert {
  padding-right: 5px;
  padding-left: 5px;
}

.title {
  margin-left: 0px !important;
  margin-top: 8px !important;
}

.icon {
  position: absolute;
  top: 15px;
  right: 10px;
}

.switch-selecter {
  margin-bottom: 3px;
}

.sound-switch {
  margin-top: 10px;
}

.separator {
  margin-bottom: 20px;
}

.card, .card-inner {
  border: none !important;
}

.title-container {
  margin-bottom: 10px;
}

.content-container, .title-container {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.flash-button {
  margin-bottom: 10px;
}

input[type=range] {
  width: 100% !important;
  margin-right: 20px;
  height: 10px;
}
</style>
